import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconNews = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M52.032 8.203c-.123.035-1.131.662-2.24 1.392-3.115 2.053-4.175 2.688-6.368 3.818a54.1 54.1 0 0 1-17.856 5.526c-2.697.339-4.682.428-9.92.446-3.567.012-4.02.041-5.182.332-3.19.797-5.923 3.006-7.416 5.993-.797 1.597-1.148 3.136-1.146 5.042 0 1.195.073 1.812.334 2.848.998 3.956 4.251 7.193 8.226 8.184 1.111.278 1.753.328 4.184.328 1.272 0 2.312.013 2.312.03 0 .016.045.355.1.752.593 4.273 2.489 8.14 5.524 11.266.849.874 1.205 1.072 1.922 1.071.585 0 1.011-.172 1.406-.567.438-.437.55-.72.55-1.384.002-.773-.115-.997-1.014-1.941-2.326-2.44-3.805-5.344-4.325-8.491-.04-.246-.085-.5-.098-.565-.022-.109.02-.114.628-.077 6.91.419 13.14 1.93 19.286 4.678 3.004 1.344 5.349 2.68 9.12 5.198 1.78 1.188 1.884 1.243 2.453 1.278.843.053 1.52-.345 1.901-1.121l.211-.428.018-20.802c.012-14.763-.003-20.922-.052-21.217-.121-.724-.72-1.41-1.395-1.598-.29-.08-.863-.076-1.163.01m-2.048 6.076c-2.774 1.794-6.299 3.614-9.52 4.914-5.708 2.303-12.14 3.753-18.064 4.07-.37.02-.852.052-1.072.072l-.4.035v14.763l.464.036c.255.02.766.052 1.136.073 4.57.252 9.661 1.227 14.272 2.731 4.572 1.492 9.24 3.699 13.097 6.192l.695.45.016-8.453c.01-4.649.01-12.238 0-16.864l-.016-8.412zm-37.418 9.15a7.36 7.36 0 0 0-6.12 4.543c-.392.97-.518 1.628-.522 2.716-.005 1.319.185 2.182.727 3.296a7.35 7.35 0 0 0 4.116 3.69c1.006.362 1.437.413 3.841.452l2.224.035V23.36l-1.84.009c-1.012.005-2.104.032-2.426.06m46.73 1.747c-.388.183-.79.58-.998.986l-.154.302v8.576l.17.32c.203.384.569.762.918.95.213.115.363.138.896.138.579 0 .668-.016.932-.172.398-.234.783-.668.93-1.048.115-.3.122-.538.122-4.476 0-3.947-.006-4.176-.123-4.478-.159-.412-.624-.909-1.029-1.099-.454-.212-1.212-.212-1.664 0" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconNews.displayName = 'IconNews';